var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isLoading)?_c('line-chart',{attrs:{"chart-data":_vm.chartData}}):_c('v-skeleton-loader',{attrs:{"type":"card"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }